module.exports = __webpack_public_path__ + "img/renwu_yao@2x.9401ff43.png";